import React from 'react';
import axios from "axios";
import Cookies from 'js-cookie';

const UserContext = React.createContext();

const demoBookings2026 = [
    {
        _id: 'demo-booking-airbnb-2026-01',
        platform: '-//Airbnb Inc//Hosting Calendar 1.0//EN',
        dates: { start: '2026-01-08', end: '2026-01-12' },
        adults: 2,
        kids: 1
    },
    {
        _id: 'demo-booking-booking-2026-02',
        platform: '-//admin.booking.com//Booking.com Calendar//EN',
        dates: { start: '2026-02-18', end: '2026-02-22' },
        adults: 4,
        kids: 0
    },
    {
        _id: 'demo-booking-homeaway-2026-04',
        platform: '-//HomeAway.com/VacationRentalCalendar//EN',
        dates: { start: '2026-04-04', end: '2026-04-10' },
        adults: 3,
        kids: 2
    },
    {
        _id: 'demo-booking-gites-2026-05',
        platform: 'ical-gites',
        dates: { start: '2026-05-14', end: '2026-05-18' },
        adults: 2,
        kids: 0
    },
    {
        _id: 'demo-booking-mypacome-2026-07',
        platform: 'Planning Manager',
        dates: { start: '2026-07-06', end: '2026-07-13' },
        adults: 5,
        kids: 1
    },
    {
        _id: 'demo-booking-client-block-2026-09',
        platform: 'rent-client',
        dates: { start: '2026-09-02', end: '2026-09-06' },
        description: 'Blocage client'
    },
    {
        _id: 'demo-booking-owner-block-2026-10',
        platform: 'back',
        dates: { start: '2026-10-17', end: '2026-10-21' },
        description: 'Sejour proprietaire'
    },
    {
        _id: 'demo-booking-unavailable-2026-12',
        platform: 'unavailable',
        dates: { start: '2026-12-03', end: '2026-12-08' },
        description: 'Indisponibilite'
    }
];

const demoPropertiesFallback = [
    {
        id: 'demo-property-2026',
        _id: 'demo-property-2026',
        name: 'Maison Demo 2026',
        archived: false,
        address: {
            number: '12',
            road: 'rue du Calendrier',
            zip: '12000',
            city: 'Rodez',
            other: ''
        },
        interventions: [],
        bookings: demoBookings2026
    }
];

function getDemoPropertiesFallback() {
    if (typeof window !== 'undefined' && Array.isArray(window.__HM_DEMO_PROPERTIES__)) {
        return window.__HM_DEMO_PROPERTIES__;
    }
    return demoPropertiesFallback;
}

/** API `getInfo()` exposes `id`; Dashboard keys tabs/panels by `_id`. */
function withStableHouseIds(houses) {
    return (houses || []).map((h) => ({
        ...h,
        _id: h._id != null && h._id !== '' ? h._id : h.id
    }));
}

let burl = process.env.REACT_APP_BURL || "https://api2.mypacome-manager.fr"
// burl = "http://localhost:3010"

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
//http://192.168.1.12:3010 http://localhost:3010 https://api.mypacome-manager.fr


export class UserProvider extends React.Component {
    state = {
        user: {},
        token: null,
        data: {}
    }
    header = {
        headers: {
            "Content-Type": "application/json"
        }
    }
    headerAuth = () => {
        return {
            headers: {
                "Content-Type": "application/json",
                "token": this.state.token
            }
        }
    }
    headerAuthFiles = () => {
        return {
            headers: {
                "Content-Type": "multipart/form-data",
                "token": this.state.token
            }
        }
    }
    setUser = async (user, token) => {
        return new Promise(((resolve, reject) => {
            this.setState({ user: user, token: token }, (err) => {
                if (err) reject(err)
                else resolve()

            })
        }))
    }
    setData = (data) => {
        return new Promise(((resolve, reject) => {
            this.setState({ data: data }, (err) => {
                if (err) reject(err)
                else resolve()
            })
        }))
    }
    logout = () => {
        Cookies.remove('MyPacomeClient', { path: '/' })
        this.setState({ user: {}, token: '' })
    }
    isLogged = () => {
        return !!this.state.token
    }
    getBurl = () => {
        return burl
    }
    apiReducer = (action, payload, option) => {
        switch (action) {
            case 'login': {
                return new Promise((resolve, reject) => {
                    axios.post(
                        burl + '/client/login',
                        payload,
                        this.header
                    )
                        .then((response) => {
                            if (response.data.generatePassword) return resolve({ generatePassword: response.data.generatePassword })
                            this.setUser(response.data.user, response.data.token)
                                .then(() => {
                                    if (option.remember) {
                                        Cookies.set('MyPacomeClient', {
                                            user: response.data.user,
                                            token: response.data.token
                                        }, { path: '/' }, { expires: 1 })
                                        return resolve()
                                    } else {
                                        Cookies.set('MyPacomeClient', {
                                            user: response.data.user,
                                            token: response.data.token
                                        }, { expires: 1, path: '/' })
                                        return resolve()
                                    }
                                })
                                .catch((err) => {
                                    return reject(err)
                                })
                        })
                        .catch((err) => {
                            return reject(err)
                        })
                })
            }
            case 'reset':
                return new Promise((resolve, reject) => {
                    axios.post(
                        burl + '/client/reset/',
                        payload,
                        this.header
                    )
                        .then((result) => {
                            console.log(result)
                            resolve(result)
                        })
                        .catch(e => reject(e))
                })
            case 'setPassword':
                return new Promise(((resolve, reject) => {
                    axios.put(
                        burl + '/client/resetPassword/',
                        payload,
                        this.header
                    )
                        .then((result) => resolve(result))
                        .catch((e) => reject(e))
                }))
            case 'creation':
                return new Promise(((resolve, reject) => {
                    axios.post(
                        burl + '/client/creation/',
                        payload,
                        this.header
                    )
                        .then((result) => resolve(result))
                        .catch((e) => reject(e))
                }))
            case 'creationStatus':
                return new Promise((resolve, reject) => {
                    axios.get(
                        burl + '/client/creation/' + encodeURIComponent(payload.token) + '/status',
                        this.header
                    )
                        .then((response) => resolve(response.data))
                        .catch((e) => reject(e))
                })
            case 'fetchData': {
                return new Promise((resolve, reject) => {
                    console.log(this.state.token)
                    axios.get(
                        burl + '/client/all/',
                        {
                            headers: {
                                token: this.state.token
                            }
                        }
                    )
                        .then((response) => {
                            let activeHouses = (response.data.properties || []).filter((property) => !property?.archived);
                            if (process.env.REACT_APP_HM_DEMO_PROPERTIES === 'true') {
                                activeHouses = [...getDemoPropertiesFallback(), ...activeHouses];
                            }
                            this.setData({ houses: withStableHouseIds(activeHouses) })
                                .then(() => {
                                    return resolve()
                                })
                                .catch((err) => {
                                    console.log(err)
                                    return reject(err)
                                })
                        })
                        .catch(e => {
                            console.log(e.message)
                            return reject(e)
                        })
                })
            }
            case 'addBooking':
                return new Promise((resolve, reject) => {
                    axios.post(
                        burl + '/client/registered/properties/' + option.name,
                        payload,
                        this.headerAuth()
                    )
                        .then(() => {
                            return resolve()
                        })
                        .catch(e => {
                            return reject(e)
                        })
                })
            default: {
                throw new Error(`Unhandled action type: ${action}`)
            }
        }
    }

    componentWillMount() {
        let cookie = Cookies.get('MyPacomeClient')
        if (cookie) {
            cookie = JSON.parse(cookie)
            this.setUser(cookie.user, cookie.token)
        }
    }

    render() {
        const { children } = this.props
        const { user, token, data } = this.state
        const { logout, isLogged, getBurl, searchIntervention, apiReducer } = this

        return (
            <UserContext.Provider
                value={
                    { user, token, data, apiReducer, searchIntervention, logout, isLogged, getBurl }
                }>
                {children}
            </UserContext.Provider>
        )
    }
}

export default UserContext
